import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import {
  DatePicker,
  Loadable,
  SelectField,
  EntitySelector
} from "components/support";
import Moment from "moment";

class Filter extends Component {
  static sOperations = [
    { value: "all", label: "Todas as Operações" },
    { value: "sale", label: "Venda" },
    { value: "purchase", label: "Compra" },
    { value: "inventory", label: "Inventário" },
    { value: "manual_input", label: "Entrada Manual" },
    { value: "manual_output", label: "Saída Manual" },
    { value: "return", label: "Devolução" }
  ];

  handleChange = ({ startDate, endDate, operation }) => {
    const { onChange } = this.props;
    const options = {};

    if (startDate) {
      options.dateFrom = Moment(startDate);
    }

    if (endDate) {
      options.dateTo = Moment(endDate);
    }

    if (operation) {
      options.operation = operation;
    }

    onChange(options);
  };

  handleField = ({ user, product }) => {
    const { onFilter } = this.props;
    const value = {};

    value.user = user;
    value.product = product;

    return onFilter(value);
  };

  render() {
    const {
      loading,
      filters,
      productSearchOptions,
      userSearchOptions,
      onSelectProduct,
      onSelectUser
    } = this.props;

    const { dateFrom, dateTo, user, product, operation } = filters;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable
          loading={loading}
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column"
          }}
          shadow
        >
          <Typography type="headline">Filtro</Typography>
          <Row>
            <Col xs={12} md={4}>
              <SelectField
                fullWidth
                options={Filter.sOperations}
                label="Operação"
                value={operation}
                onChange={(_, operation) => this.handleChange({ operation })}
              />
            </Col>
            <Col xs={12} md={8}>
              <DatePicker
                multiple
                label="Período"
                modal
                fullWidth
                startDate={dateFrom}
                endDate={dateTo}
                onChange={({ startDate, endDate }) =>
                  this.handleChange({ startDate, endDate })
                }
              />
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <EntitySelector
                label="Produto"
                title="Selecionar Produto"
                value={product.name}
                searchOptions={productSearchOptions}
                onSelect={product => onSelectProduct(product)}
                parser={product => ({ key: product.uuid, title: product.name })}
                nullSelection={{ uuid: "", name: "" }}
              />
            </Col>
            <Col xs={6}>
              <EntitySelector
                label="Usuário"
                title="Selecionar Usuário"
                value={user.name}
                searchOptions={userSearchOptions}
                onSelect={user => onSelectUser(user)}
                parser={user => ({ key: user.uuid, title: user.name })}
                nullSelection={{ uuid: "", name: "" }}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/app/management/stock-movement-report/filters/index.jsx